import { CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME } from "models/generateCustomAttributesSchema";

export function optionLabel(options: any[], value: any) {
  return options.find((t: { value: any }) => t.value === value)?.label;
}

export function optionWithGroupLabel(
  groups: any[],
  value: any,
  country?: string,
) {
  for (const group of groups) {
    if (group.options === undefined) continue;

    const foundOption = group.options.find(
      (option: { value: any; country: any }) =>
        option.value === value &&
        (country === undefined || option.country === country),
    );
    if (foundOption) {
      return foundOption.label;
    }
  }
  return undefined;
}

/**
 * Unified government entity validation for real-time and form submission
 * Supports optional notifications for enhanced user feedback
 * @returns boolean - true if validation passes, false if it fails
 */
export const validateGovernmentEntity = ({
  country,
  govEntity,
  filteredOptions,
  setValue,
  fieldPath = CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME,
  isEditModeInit = false,
  addNotification,
}: {
  country: string;
  govEntity: string;
  filteredOptions: any[];
  setValue: (path: string, value: string) => void;
  fieldPath?: string;
  isEditModeInit?: boolean;
  addNotification?: Function;
}): boolean => {
  if (isEditModeInit) return true;

  const opts = filteredOptions ?? [];

  if (country) {
    const isValid = opts.some((grp) =>
      (grp?.options ?? []).some((opt: any) => opt.value === govEntity),
    );

    if (!isValid && govEntity) {
      setValue(`${fieldPath}.governmentEntity`, "");

      if (addNotification) {
        addNotification({
          type: "warning",
          header: "Invalid government entity",
          content:
            "The government entity value has been cleared because it's not valid for the selected country.",
          dismissible: true,
          timeout: 5000,
        });
      }
      return false;
    }
  } else if (govEntity) {
    setValue(`${fieldPath}.governmentEntity`, "");
    return false;
  }

  return true;
};
